module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAASFJREFUaAXtl80NwjAMhRsk7rBKZ2AOLszDBIwCEhO0kyCYAMoLin2oGnpIcBPxIlmxnB8/f84lTcORRmAYhi3sAmvTblrgdBDfYfbjDqunCIj15EU83M+oowhInRIfaii8E0F8L2oj83GBFz2fMogfP5txDScE3Pxtxjso3hi4piN5RWHskLwxcE1H8orC2CF5Y+CajuQVhbFD8sbANR3JK4oFHNA/w76NKxbL+4wIK4hrYf7jHRtPLOxlf5EzBLKIIjrDThTRBohgJ9iJjAT4nDLCTLqKnUjCl/EwO5ERZtJV7EQSvoyH2YkJmKuJ2E9DzrkeCXawRySR/5KuI2vlhCPP6YX4oRyVM0pGRdQlXmoLRdyqIi/iZYb4jfh/N78BozRRmyNhhLkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/left-arrow.png
// module id = Y/l4
// module chunks = 1